/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { withTranslation } from 'react-i18next';

import Loader from '../../Common/Loader';
import { commonStyleForEditPersonalInfo } from '../../Common/CommonStyle';
import { IIFC } from 'react-iifc';
import { useMediaQuery } from 'react-responsive';
import PageHeaderTitle from '../../Common/Profile/PageHeaderTitle';
import { hot } from 'react-hot-loader';
const { MOBILE } = window.AppConfig.SCREEN_SIZE;

class BaseForm extends React.Component {
	render() {
		const { t, classes, isLoading } = this.props;
		return (
			<IIFC>
				{() => {
					const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE})` });

					return (
						<section className="cashoutform">
							<PageHeaderTitle
								title="Cash Out Wallet"
								isMobile={isMobile}
								className={isMobile ? 'cashout  p-x-16' : ' '}
								onClick={this.props.closeProfileScreen}
							/>
							<Grid alignItems="center" className={classes.root} spacing={2} container justify="center">
								<Grid
									alignItems="center"
									className={classes.root}
									item
									spacing={10}
									xs={12}
									justify="center"
									sm={12}>
									<Paper className={classes.paper}>
										<Card className={classes.root} variant="outlined">
											{isMobile ? null : (
												<Button
													onClick={this.props.closeProfileScreen}
													size="small"
													style={{ display: 'inline-block', float: 'left' }}>
													<ArrowBackIosIcon />
													{t('buttons.back_profile')}
												</Button>
											)}
											<Grid
												alignItems="center"
												className={classes.root}
												container
												justify="center"
												spacing={2}>
												<Grid alignItems="center" item sm={8} justify="center" xs={12}>
													<Grid
														alignItems="center"
														className={classes.root}
														container
														justify="center"
														spacing={2}>
														{this.props.children}
													</Grid>
												</Grid>
											</Grid>
										</Card>
									</Paper>
								</Grid>
							</Grid>
							{isLoading ? <Loader /> : ''}
						</section>
					);
				}}
			</IIFC>
		);
	}
}

export default hot(module)(withStyles(commonStyleForEditPersonalInfo)(withTranslation()(BaseForm)));
